import React from 'react';
import { useNavigate } from 'react-router-dom';

import * as O from 'fp-ts/Option';
import { useAtomValue } from 'jotai';

import LibraryIcon from '../../assets/images/library.svg';
import PerformanceIcon from '../../assets/images/performance.svg';
import TodayCardsIcon from '../../assets/images/todayCard.svg';
import { useIsAssessmentCompleted } from '../../hooks/useIsAssessmentCompleted';
import { userState } from '../../model/state/userState';

export const BottomMobileMenu = () => {
  const navigate = useNavigate();
  const user = useAtomValue(userState);
  const libraryEnabled = O.toNullable(user)?.partner.enableLibrary;
  const performanceEnabled = O.toNullable(user)?.partner.enableUserPerformance;
  const isAssessmentCompleted = useIsAssessmentCompleted();

  const buttonsMap = [
    {
      buttonText: "Today's Cards",
      icon: TodayCardsIcon,
      onClickHandler: () => {
        navigate('/WelcomeBack');
      },
    },
    {
      buttonText: 'Performance',
      icon: PerformanceIcon,
      isInvisible: !performanceEnabled,
      onClickHandler: () => {
        navigate('/Performance');
      },
    },
    {
      buttonText: 'Library',
      icon: LibraryIcon,
      isInvisible: !libraryEnabled,
      onClickHandler: () => {
        navigate('/Library');
      },
    },
  ];

  return (
    <>
      {!isAssessmentCompleted ? null : (
        <div className="flex items-end justify-around border-t border-[#E6E8EC] pb-4 pt-2 lg:hidden">
          {buttonsMap.map((button) => (
            <React.Fragment key={button.buttonText}>
              {button.isInvisible ? null : (
                <button
                  className="flex flex-col items-center text-xs text-[#040110]"
                  onClick={button.onClickHandler}
                  type="button"
                >
                  <img alt={button.buttonText} className="mb-1" src={button.icon} />
                  <span>{button.buttonText}</span>
                </button>
              )}
            </React.Fragment>
          ))}
        </div>
      )}
    </>
  );
};
